module.exports = __webpack_public_path__ + "static/img/1.0ac2d9e1.jpg";